import { Component } from '@angular/core';
import { DevelopChallengeComponent } from '../develop-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-develop-challenge-solution-prototype',
  templateUrl: './develop-challenge-solution-prototype.component.html',
  styleUrls: ['./develop-challenge-solution-prototype.component.scss']
})
export class DevelopChallengeSolutionPrototypeComponent {
  constructor(public developChallengeComponent: DevelopChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const dd = this.developChallengeComponent?.doing_dropdown || '';
    const dc = this.developChallengeComponent?.doing_content || '';
    const context = dd ? (dd + ' ' + dc) : dc;
    this.aiService.openSidebar(
      'develop', 'solution-prototype', context,
      'Generate 5 solution prototype descriptions {persona}. Current context: {context}',
      'doing_content', this.developChallengeComponent
    );
  }
}
